import React, { useState, useEffect, useContext } from 'react'
import { Wrapper, Form } from './style.css'
import { rutValidate, rutFormat } from 'rut-helpers'
import axios from 'axios'
import SiteContext from '@/context/SiteContext'
import { dltrack } from '@/utilities'

const useForm = ({ initialValues, onSubmit, validate }) => {
  const [values, setValues] = useState(initialValues || {})
  const [touchedValues, setTouchedValues] = useState({})
  const [errors, setErrors] = useState({})

  const handleChange = event => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    setValues({
      ...values,
      [name]: value,
    })
  }

  const handleBlur = event => {
    const target = event.target
    const name = target.name

    setTouchedValues({
      ...touchedValues,
      [name]: true,
    })
    const e = validate(values)

    setErrors({
      ...e,
    })
  }

  const handleSubmit = event => {
    event.preventDefault()
    const e = validate(values)
    setErrors({
      ...errors,
      ...e,
    })
    onSubmit({ values, e })
  }

  return {
    values,
    touchedValues,
    errors,
    handleChange,
    handleSubmit,
    handleBlur,
  }
}

const Register = ({ onRegistered }) => {
  const { answers } = useContext(SiteContext)
  const [globalError, setGlobalError] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [finished, setFinished] = useState(false)

  useEffect(() => {
    if (globalError) {
      setTimeout(() => {
        setGlobalError(false)
      }, 4000)
    }
  }, [globalError])

  useEffect(() => {
    if (finished) {
      setTimeout(() => {
        onRegistered()
      }, 500)
    }
  }, [finished])
  const {
    values,
    touchedValues,
    errors,
    handleChange,
    handleSubmit,
    handleBlur,
  } = useForm({
    initialValues: {
      rut: '',
      email: '',
      nombre: '',
    },
    onSubmit(values) {
      values.values.rut = rutFormat(values.values.rut)
      const err = values.e ? values.e : null
      const val = values.values ? values.values : null

      if (Object.keys(err).length > 0) {
        setProcessing(false)
      } else {
        setProcessing(true)

        const bodyFormData = new FormData()
        bodyFormData.append('nombre', val.nombre)
        bodyFormData.append('rut', val.rut)
        bodyFormData.append('email', val.email)
        bodyFormData.append('preguntasTotal', answers.length)

        answers.map((answer, index) => {
          bodyFormData.append(`categoria_${index}`, answer.category)
          bodyFormData.append(`votacionID_${index}`, index)
          bodyFormData.append(`rostro_${index}`, answer.answer)
        })

        axios({
          method: 'post',
          url: `https://formulario.latercera.com/encuestas/inc/votacion-encuesta-copihuedeoro.php`,
          data: bodyFormData,
        })
          .then(res => {
            setProcessing(false)
            if (res.data && res.data === 'ERROR <br />Usuario ya votó') {
              dltrack({ event: 'error', error: 'yahabiavotado', ...val })

              setGlobalError(
                'Este usuario ya ha participado anteriormente. Por favor, intenta con otro email u otro RUT.',
              )
            } else if (res.data && res.data === 'OK') {
              const totrack = {
                event: 'finalizado',
              }
              dltrack(totrack)
              setFinished(true)
            } else {
              setFinished(true)
            }
          })
          .catch(error => {
            console.log(error)
            setProcessing(false)
          })
      }
    },
    validate(values) {
      const errorobj = {}
      if (values.rut === '') {
        errorobj.rut = 'Ingresa un RUT'
      } else if (!rutValidate(values.rut)) {
        errorobj.rut = 'RUT inválido'
      } else {
        delete errorobj.rut
      }

      if (values.nombre === '') {
        errorobj.nombre = 'El nombre es requerido'
      } else if (values.nombre.length < 4) {
        errorobj.nombre = 'Necesitamos tu nombre completo'
      } else {
        delete errorobj.nombre
      }

      if (values.email === '') {
        errorobj.email = 'El email es requerido'
      } else {
        delete errorobj.email
      }
      setProcessing(false)
      return errorobj
    },
  })

  useEffect(() => {
    console.log('los errors', errors)
  }, [errors])
  return (
    <Wrapper className="grid-cols-12 sm:grid landscape:grid">
      <div className="flex items-center justify-center p-4 text-left sm:col-span-7 sm:pl-32 landscape:pl-4 landscape col1">
        <div>
          <h2 className="text-2xl font-bold leading-none sm:text-6xl landscape:text-2xl ">
            ¡Último paso!
          </h2>
          <h3 className="mb-2 text-2xl font-normal leading-none landscape:text-xl landscape:leading-none">
            Regístrate y estarás participando por el sorteo de{' '}
            <strong>1 depiladora IPL Philips Lumea BRI920/00</strong>
          </h3>
        </div>
      </div>
      <div className="flex items-center justify-center col-span-8 p-4 text-left sm:col-span-5 bg-grispurpura ">
        <iframe
          src="https://survey.alchemer.com/s3/6430450/20210709-LABORATORIO-DE-CONTENIDOS"
          width="100%"
          height="400"></iframe>
        {/* <Form onSubmit={handleSubmit} className="theform">
          <label className="block mb-4">
            <span className="block leading-none text-white">Nombre</span>
            <input
              name="nombre"
              type="text"
              className="block w-full mt-1 text-black bg-gray-100 border-transparent rounded-md focus:border-gray-500 focus:bg-white focus:ring-0"
              value={values.nombre}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Ejemplo: Clara del Valle"
            />
            {errors.nombre && (
              <span className="text-sm text-red-500 error">
                {errors.nombre}
              </span>
            )}
          </label>

          <label className="block mb-4">
            <span className="block leading-none text-white">RUT</span>
            <input
              name="rut"
              type="text"
              className="block w-full mt-1 text-black bg-gray-100 border-transparent rounded-md focus:border-gray-500 focus:bg-white focus:ring-0"
              value={rutFormat(values.rut)}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Ejemplo: 15.123.456-7"
            />
            {errors.rut && (
              <span className="text-sm text-red-500 error">{errors.rut}</span>
            )}
          </label>

          <label className="block mb-4">
            <span className="block leading-none text-white">Email</span>
            <input
              name="email"
              type="email"
              className="block w-full mt-1 text-black bg-gray-100 border-transparent rounded-md focus:border-gray-500 focus:bg-white focus:ring-0"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder="Ejemplo: tuemail@gmail.com"
            />
            {errors.email && (
              <span className="text-sm text-red-500 error">{errors.email}</span>
            )}
          </label>

          {globalError && (
            <div
              className="p-4 text-sm text-red-800 bg-red-300 rounded-sm"
              dangerouslySetInnerHTML={{
                __html: globalError,
              }}></div>
          )}

          <button
            type="submit"
            disabled={
              processing || Object.keys(errors).length > 0 ? true : false
            }
            className={`w-full px-4 pt-3 pb-2 mt-4 text-xl font-bold rounded-md sm:text-2xl focus:outline-none ${
              Object.keys(errors).length > 0
                ? 'bg-red-300 text-red-200'
                : processing
                ? 'bg-blue-400'
                : 'bg-verde'
            }`}>
            {processing ? (
              <span className="inline-flex items-center text-center">
                <svg
                  class="animate-spin -ml-1 mr-3 h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24">
                  <circle
                    class="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"></circle>
                  <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Procesando...
              </span>
            ) : (
              <span className="items-center block py-2 pt-3 pb-2 text-center rounded bg-turquesa">
                Participar
              </span>
            )}
          </button>
        </Form>
       */}
      </div>
    </Wrapper>
  )
}

export default Register
